import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { MinusIcon, PlusIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { faqs } from '../data/faqs';
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  return <section aria-labelledby="faq-title" className="bg-brand-ivory px-4 py-20 md:py-28" data-id="element-71" data-mp="1ntzwd4buliz7">
      <Reveal className="mx-auto max-w-3xl" data-id="element-72" data-mp="2bju8fjocf3ie">
        <div className="mb-12 text-center" data-id="element-73" data-mp="2bkvt8fv5v4db">
          <p className="mb-3 text-xs font-extrabold uppercase tracking-[0.18em] text-brand-teal-ink" data-id="element-74" data-mp="2flpipdo94r8b">BON À SAVOIR</p>
          <h2 id="faq-title" className="text-3xl font-extrabold tracking-tight text-brand-navy md:text-4xl" data-id="element-75" data-mp="21vccpgux7mlm">
            Questions fréquentes
          </h2>
        </div>
        <div className="space-y-3" data-id="element-76" data-mp="2uj87uh4ud6ga">
          {faqs.map(({
          question,
          answer
        }, index) => {
          const open = openIndex === index;
          const panelId = `faq-panel-${index}`;
          return <div key={question} className="overflow-hidden rounded-2xl border border-brand-line bg-white" data-id="element-77" data-mp="1vpht7ww1rnrs" data-mpi={index}>
                <button id={`faq-button-${index}`} type="button" onClick={() => setOpenIndex(open ? null : index)} aria-expanded={open} aria-controls={panelId} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left font-bold text-brand-navy focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand-teal md:px-6" data-id="element-78" data-mp="1ropjl2j9jguz">
                  <span className="text-sm md:text-base" data-id="element-79" data-mp="2oeotb0b5glf5">{question}</span>
                  {open ? <MinusIcon className="h-5 w-5 shrink-0 text-brand-teal" aria-hidden="true" data-id="element-80" data-mp="2jf3ucpvzcd2f" /> : <PlusIcon className="h-5 w-5 shrink-0 text-brand-teal" aria-hidden="true" data-id="element-81" data-mp="u174zb2x7kj2" />}
                </button>
                <AnimatePresence initial={false} data-id="element-82" data-mp="p3ozjuo43nft">
                  {open && <motion.div id={panelId} role="region" aria-labelledby={`faq-button-${index}`} className="overflow-hidden" initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.22,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-83" data-mp="2p5oma2hdzwwr">
                      <p className="px-5 pb-6 text-sm leading-relaxed text-slate-600 md:px-6" data-id="element-84" data-mp="3czonqci2ug22">{answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </div>;
        })}
        </div>
      </Reveal>
    </section>;
}